var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState, useCallback, } from "react";
import { acquireGraphToken, getCurrentAccount, signOut } from "./ssoHelper";
const AuthContext = createContext({
    accessToken: null,
    displayName: null,
    upn: null,
    loading: true,
    error: null,
    retry: () => { },
    logout: () => __awaiter(void 0, void 0, void 0, function* () { }),
});
export function AuthProvider({ children }) {
    const [accessToken, setAccessToken] = useState(null);
    const [displayName, setDisplayName] = useState(null);
    const [upn, setUpn] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const authenticate = useCallback((...args_1) => __awaiter(this, [...args_1], void 0, function* (interactive = false) {
        var _a, _b;
        setLoading(true);
        setError(null);
        try {
            const token = yield acquireGraphToken({ interactive });
            setAccessToken(token);
            const account = yield getCurrentAccount();
            if (account) {
                setDisplayName((_a = account.name) !== null && _a !== void 0 ? _a : null);
                setUpn((_b = account.username) !== null && _b !== void 0 ? _b : null);
            }
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "Authentication failed";
            setError(msg);
            console.error("[AuthProvider]", err);
        }
        finally {
            setLoading(false);
        }
    }), []);
    const logout = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield signOut();
        setAccessToken(null);
        setDisplayName(null);
        setUpn(null);
    }), []);
    useEffect(() => {
        // Only run inside Office context
        Office.onReady(() => {
            void authenticate(false);
        });
    }, [authenticate]);
    const retry = useCallback(() => {
        void authenticate(true);
    }, [authenticate]);
    return (React.createElement(AuthContext.Provider, { value: { accessToken, displayName, upn, loading, error, retry, logout } }, children));
}
export function useAuth() {
    return useContext(AuthContext);
}
